var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAc = function SvgAc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ac_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ac_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ac_svg__b",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ac_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.5 16.65-3.425 3.375a.42.42 0 0 1-.337.15A.4.4 0 0 1 7.4 20a.4.4 0 0 1-.175-.337q0-.213.175-.363l4.1-4.1v-2.7H8.8l-4.125 4.125a.42.42 0 0 1-.337.15.46.46 0 0 1-.363-.175.42.42 0 0 1-.15-.337q0-.213.15-.338L7.35 12.5H2.975a.46.46 0 0 1-.337-.137A.5.5 0 0 1 2.5 12a.5.5 0 0 1 .138-.35q.137-.15.362-.15h4.35L3.975 8.1a.42.42 0 0 1-.15-.338A.46.46 0 0 1 4 7.4q.125-.15.338-.15.212 0 .362.15l4.1 4.1h2.7V8.8L7.375 4.7a.42.42 0 0 1-.15-.338A.46.46 0 0 1 7.4 4q.125-.15.338-.15.212 0 .337.15L11.5 7.35V3q0-.2.137-.35A.47.47 0 0 1 12 2.5q.2 0 .35.15t.15.35v4.35L15.9 4q.125-.15.338-.15.212 0 .362.15t.15.362q0 .213-.15.338l-4.1 4.1v2.7h2.7l4.1-4.1q.125-.15.338-.15a.46.46 0 0 1 .362.175q.15.125.15.337T20 8.1l-3.35 3.4H21q.2 0 .35.15t.15.35a.47.47 0 0 1-.15.363.5.5 0 0 1-.35.137h-4.35L20 15.925q.15.125.15.338 0 .212-.15.337a.46.46 0 0 1-.362.175.4.4 0 0 1-.338-.175l-4.1-4.1h-2.7v2.7l4.1 4.125q.15.125.15.338a.46.46 0 0 1-.175.362.42.42 0 0 1-.337.15.42.42 0 0 1-.338-.15l-3.4-3.375v4.375q0 .2-.15.338a.5.5 0 0 1-.35.137.5.5 0 0 1-.363-.137A.5.5 0 0 1 11.5 21z"
  })))));
};
export default SvgAc;